import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef, // 1. Import ViewChild
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { ValidationMessageService } from "@app/shared/services/validation-message/validation-message.service";

@Component({
  selector: "crm-call-log",
  templateUrl: "./call-log.component.html",
  styleUrls: ["./call-log.component.scss"],
})
export class CallLogComponent implements OnInit {
  @Input() type: string = "add";
  @Input() buttonName: string;
  @Input() modalTitle: string;
  @Input() formValid: boolean;

  @Output() onSubmit = new EventEmitter();

  // 2. Add this ViewChild. This gets the <ng-template #ModalRef> from your HTML file.
  @ViewChild("ModalRef", { static: false }) ModalRef: TemplateRef<any>;

  modalRef: BsModalRef; // This is for the *opened* modal instance

  // modal config to unhide modal when clicked outside
  config = {
    backdrop: true,
    ignoreBackdropClick: true,
  };

  constructor(
    private modalService: BsModalService,
    private validationMessageService: ValidationMessageService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() { }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  public show() {
    // 3. This is the fix.
    // Call openModal with the TEMPLATE (this.ModalRef),
    // not the INSTANCE (this.modalRef).
    this.openModal(this.ModalRef);
  }

  onSave(): void {
    this.onSubmit.emit(true);

    if (this.formValid) {
      // to hide the red border on form field
      this.validationMessageService.formSubmitted = false;
      this.modalRef.hide();
    }
    this.cdr.detectChanges();
  }

  onCancel(): void {
    // to hide the red border on form field
    this.validationMessageService.formSubmitted = false;
    this.modalRef.hide();
  }
}
